import {$, w} from './constants';

w.load(() => {

	// Home Slider
	$('.home_slider_JS').slick({
		dots: false,
		arrows: false,
		speed: 400,
		slide: '.home_slide_JS',
		infinite: true,
		adaptiveHeight: true,
		autoplay: true,
		pauseOnHover: false,
		autoplaySpeed: 4500,
	});

	// Catering Slider
	$('.catering_slider_JS').slick({
		dots: false,
		arrows: false,
		speed: 400,
		arrows: true,
		infinite: true,
		autoplay: true,
		adaptiveHeight: true,
		pauseOnHover: false,
		autoplaySpeed: 4000,
	});

	// Init default or url menu section
	const urlParams = new URLSearchParams(window.location.search);
	const url_section = urlParams.get('section');
	if (url_section) {
		$('.menu_btn_JS').removeClass('active')
		$('.menu_section_JS').hide()
		$('.menu_icon_JS').hide()
		$('.menu_btn_JS[data-section="'+url_section+'"]').addClass('active')
		$('.menu_section_JS[data-section="'+url_section+'"]').slideDown(0,function(){
			$(this).css('overflow','visible')
			$(this).find('.menu_icon_JS').fadeIn()
		})
	} else {
		$('.menu_section_JS').each(function(){
			if($(this).hasClass('active')){
				$(this).slideDown(0,function(){
					$(this).css('overflow','visible')
					$(this).find('.menu_icon_JS').addClass('active')
				})
			}
		})
	}

	// Menu sections
	$('.menu_btn_JS').click(function () {
		// if (!$(this).hasClass('active')) {
			var section = $(this).attr('data-section')
			$('.menu_btn_JS').removeClass('active')
			$(this).addClass('active')
			$('.menu_icon_JS').hide()
			$('.menu_section_JS').hide()
			$('.menu_section_JS[data-section="'+section+'"]').slideDown(300,function(){
				$(this).css('overflow','visible')
				$(this).find('.menu_icon_JS').fadeIn()
			})
		// }
	})

	// Footer Ticker
	const tickerWrap = document.querySelector('.ticker_JS');
	const items = Array.from(tickerWrap.children);

	// Duplicate items until wrap width is at least twice the container width
	const containerWidth = tickerWrap.parentElement.offsetWidth;
	let totalWidth = tickerWrap.scrollWidth;

	while (totalWidth < containerWidth * 2) {
		items.forEach(item => {
			const clone = item.cloneNode(true);
			tickerWrap.appendChild(clone);
		});
		totalWidth = tickerWrap.scrollWidth;
	}

	// Animate with requestAnimationFrame for perfectly smooth scroll
	let scroll = 0;
	function animateTicker() {
		scroll += 1; // pixels per frame; increase for faster scrolling
		if (scroll >= tickerWrap.scrollWidth / 2) scroll = 0; // seamless loop
		tickerWrap.style.transform = `translateX(-${scroll}px)`;
		requestAnimationFrame(animateTicker);
	}

	animateTicker();

	// Toggle menu item details
	$('.menu_item_JS').click(function () {
		$(this).find('.menu_toggle_JS').slideToggle('fast')
	})

	// About badge scroll inertia
	const badge = document.querySelector('.about_badge_JS');
	if(badge){
		let targetY = 0;
		let currentY = 0;
		let rotation = 0;

		let lastScroll = window.scrollY;
		let scrollVelocity = 0;

		const inertia = 0.08;      // movement inertia
		const spinSpeed = 0.4;     // steady base spin
		const scrollSpin = 0.06;   // how much scroll adds rotation

		function lerp(a,b,t){
			return a + (b - a) * t;
		}

		function animate(){
			const currentScroll = window.scrollY;
			scrollVelocity = Math.abs(currentScroll - lastScroll); // always positive
			lastScroll = currentScroll;
			targetY = currentScroll * 0.3;
			currentY = lerp(currentY, targetY, inertia);
			rotation += spinSpeed;
			rotation += scrollVelocity * scrollSpin;
			badge.style.transform = `translateY(${currentY}px) rotate(${rotation}deg)`;
			requestAnimationFrame(animate);
		}

		animate();
	}

});

// Rotate About badge on scroll
if ($('.about_badge_JS').length) {
	const badge = document.querySelector('.about_badge_JS');
	window.addEventListener('scroll', () => {
		const scrollTop = window.scrollY;
		const rotation = scrollTop * 0.3;
		badge.style.transform = `rotate(${rotation}deg)`;
	});
}


$(document).ready(function() {

	$('.mobile_btn_JS').click(function () {
		$(this).toggleClass('active')
		$('.mobile_JS').slideToggle('fast')
	})

})
